export const departments = ['IT', 'HR', 'Planning', 'Accounting', 'Customer Services', 'Billing'];
export const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const leaves=[
     {
         id: 1,
         employeeName: 'Mohammed El Idrissi',
         employeeId: 'EMP001',
         department: 'IT',
         position: 'Senior Developer',
         email: 'mohammed.elidrissi@company.ma',
         manager: 'Fatima Zahra',
         leaveType: 'Vacation',
         startDate: '2025-06-20',
         endDate: '2025-06-25',
         reason: 'Family trip to Marrakech',
         priority: 'Low',
         status: 'Approved',
         approvedBy: 'Fatima Zahra',
         approvedDate: '2025-06-15',
         remainingDays: { vacation: 12, sick: 8, personal: 3 },
         comments: 'Enjoy your trip!',
         coverageArranged: true,
         handoverCompleted: true,
         submittedDate: '2025-06-10'
       },
       {
         id: 2,
         employeeName: 'Amina Benali',
         employeeId: 'EMP002',
         department: 'HR',
         position: 'HR Manager',
         email: 'amina.benali@company.ma',
         manager: 'Youssef Amrani',
         leaveType: 'Sick',
         startDate: '2025-06-18',
         endDate: '2025-06-18',
         reason: 'Medical check-up',
         priority: 'High',
         status: 'Pending',
         remainingDays: { vacation: 15, sick: 7, personal: 5 },
         coverageArranged: false,
         handoverCompleted: false,
         submittedDate: '2025-06-17'
       },
       {
         id: 3,
         employeeName: 'Omar Lahlou',
         employeeId: 'EMP003',
         department: 'Planning',
         position: 'Planner',
         email: 'omar.lahlou@company.ma',
         manager: 'Khadija El Ouafi',
         leaveType: 'Personal',
         startDate: '2025-06-22',
         endDate: '2025-06-24',
         reason: 'Wedding preparations',
         priority: 'Medium',
         status: 'Approved',
         approvedBy: 'Khadija El Ouafi',
         approvedDate: '2025-06-16',
         remainingDays: { vacation: 20, sick: 10, personal: 2 },
         comments: 'Best wishes!',
         coverageArranged: true,
         handoverCompleted: true,
         submittedDate: '2025-06-12'
       },
       {
         id: 4,
         employeeName: 'Latifa El Hajjaji',
         employeeId: 'EMP004',
         department: 'Accounting',
         position: 'Accountant',
         email: 'latifa.elhajjaji@company.ma',
         manager: 'Abdelkader Tazi',
         leaveType: 'Vacation',
         startDate: '2025-07-01',
         endDate: '2025-07-05',
         reason: 'Summer holiday in Agadir',
         priority: 'Low',
         status: 'Pending',
         remainingDays: { vacation: 18, sick: 12, personal: 4 },
         coverageArranged: false,
         handoverCompleted: false,
         submittedDate: '2025-06-15'
       },
       {
         id: 5,
         employeeName: 'Hassan Ouazzani',
         employeeId: 'EMP005',
         department: 'Customer Services',
         position: 'Customer Support',
         email: 'hassan.ouazzani@company.ma',
         manager: 'Naima El Idrissi',
         leaveType: 'Sick',
         startDate: '2025-06-25',
         endDate: '2025-06-26',
         reason: 'Flu recovery',
         priority: 'High',
         status: 'Pending',
         remainingDays: { vacation: 10, sick: 6, personal: 3 },
         coverageArranged: true,
         handoverCompleted: false,
         submittedDate: '2025-06-24'
       },
       {
         id: 6,
         employeeName: 'Zineb Chraibi',
         employeeId: 'EMP006',
         department: 'Billing',
         position: 'Billing Specialist',
         email: 'zineb.chraibi@company.ma',
         manager: 'Rachid Benjelloun',
         leaveType: 'Personal',
         startDate: '2025-06-28',
         endDate: '2025-06-30',
         reason: 'Family event',
         priority: 'Medium',
         status: 'Approved',
         approvedBy: 'Rachid Benjelloun',
         approvedDate: '2025-06-20',
         remainingDays: { vacation: 15, sick: 9, personal: 1 },
         comments: 'Take care!',
         coverageArranged: true,
         handoverCompleted: true,
         submittedDate: '2025-06-19'
       },
       {
         id: 7,
         employeeName: 'Youssef Amrani',
         employeeId: 'EMP007',
         department: 'HR',
         position: 'HR Assistant',
         email: 'youssef.amrani@company.ma',
         manager: 'Amina Benali',
         leaveType: 'Sick',
         startDate: '2025-06-21',
         endDate: '2025-06-21',
         reason: 'Doctor appointment',
         priority: 'Medium',
         status: 'Rejected',
         approvedBy: null,
         approvedDate: null,
         remainingDays: { vacation: 15, sick: 7, personal: 5 },
         comments: 'Insufficient notice',
         coverageArranged: false,
         handoverCompleted: false,
         submittedDate: '2025-06-20'
       }
];